import { NgForm } from '@angular/forms';

export class CommonMeansAgainstFireClass {
  idCommonMeansAgainstFire: number | null = null;
  idProductsTypes: number | null = null;
  Description: string = '';
  RequestOther: boolean = false;
  DateStart: Date | null = null;
  DateEnd: Date | null = null;
  Order: number | null = null;
  UUID: string = '';
  UUIDLastChange: string = '';
}

export class CommonTypeOfConstructionClass {
  idTypeOfConstruction: number | null = null;
  idProductsTypes: number | null = null;
  Description: string = '';
  RequestOther: boolean = false;
  DateStart: Date | null = null;
  DateEnd: Date | null = null;
  Order: number | null = null;
  UUID: string = '';
  UUIDLastChange: string = '';
}

export class CommonTypeOfHousingClass {
  idProductsTypesTypeOfHousing: number | null = null;
  idProductsTypes: number | null = null;
  Description: string = '';
  RequestOther: boolean = false;
  DateStart: Date | null = null;
  DateEnd: Date | null = null;
  Order: number | null = null;
  UUID: string = '';
  UUIDLastChange: string = '';
}

export class CommonMeansOfSecurityClass {
  idCommonMeansOfSecurity: number | null = null;
  idProductsTypes: number | null = null;
  Description: string = '';
  RequestOther: boolean = false;
  DateStart: Date | null = null;
  DateEnd: Date | null = null;
  Order: number | null = null;
  UUID: string = '';
  UUIDLastChange: string = '';
}

export class ContagemClass {
  Total: number | null = null;
}

export class CommonInterests {
  idInterests: number | null = null;
  Description: string = '';
  AskJustification: boolean = false;
  Order: number | null = null;
  DateStart: Date | null = null;
  DateEnd: Date | null = null;
  UUID: string = '';
  UUIDLastChange: string = '';
}

export class CommonSortAux {
  ClassName: string = '';
  Array: any;
}

export class CommonAutoCarMaintenance {
  idCommonAutoCarMaintenance: number | null = null;
  Description: string = '';
  DateStart: Date | null = null;
  DateEnd: Date | null = null;
  Order: number | null = null;
  LibertyCode: string = '';
  Default: number | null = null;
  UUID: string = '';
  UUIDLastChange: string = '';
}

export class HTML {
  HTMLText: string = '';
  isConfirmed: boolean = false;
}

export class CommonAutoCarReplacement {
  idCommonAutoCarReplacement: number | null = null;
  Description: string = '';
  DateStart: Date | null = null;
  DateEnd: Date | null = null;
  Order: number | null = null;
  LibertyCode: string = '';
  Default: number | null = null;
  UUID: string = '';
  UUIDLastChange: string = '';
}

export class CommonAutoPassengers {
  idCommonAutoPassengers: number | null = null;
  Description: string = '';
  PassengersType: string = '';
  DateStart: Date | null = null;
  DateEnd: Date | null = null;
  Order: number | null = null;
  LibertyCode: string = '';
  Default: number | null = null;
  UUID: string = '';
  UUIDLastChange: string = '';
}

export class CommonAutoDeductible {
  idCommonAutoDeductible: number | null = null;
  idCommonAutoCampaign: number | null = null;
  Description: string = '';
  DateStart: Date | null = null;
  DateEnd: Date | null = null;
  Order: number | null = null;
  LibertyCode: string = '';
  Default: number | null = null;
  UUID: string = '';
  UUIDLastChange: string = '';
}

export class CommonAutoBrokenGlassClass {
  idCommonAutoBrokenGlass: number | null = null;
  Description: string = '';
  DateStart: Date | null = null;
  DateEnd: Date | null = null;
  Order: number | null = null;
  LibertyCode: string = '';
  Default: number | null = null;
  UUID: string = '';
  UUIDLastChange: string = '';
}

export class CommonLiabilityClass {
  idCommonAutoLiability: number | null = null;
  Description: string = '';
  DateStart: Date | null = null;
  DateEnd: Date | null = null;
  Order: number | null = null;
  LibertyCode: string = '';
  Default: number | null = null;
  UUID: string = '';
  UUIDLastChange: string = '';
}

export class CommonKeepPriceAsNewClass {
  idCommonAutoVehicleKeepPriceAsNew: number | null = null;
  Description: string = '';
  DateStart: Date | null = null;
  DateEnd: Date | null = null;
  Order: number | null = null;
  LibertyCode: string = '';
  Default: number | null = null;
  UUID: string = '';
  UUIDLastChange: string = '';
}

export class CommonEntityTypeClass {
  idCommonEntityType: number | null = null;
  Description: string = '';
  DateStart: Date | null = null;
  DateEnd: Date | null = null;
  Order: number | null = null;
  LibertyCode: string = '';
  Default: number | null = null;
  UUID: string = '';
  UUIDLastChange: string = '';
}

export class CommonAutoBrandClass {
  idCommonAutoBrand: number | null = null;
  GroupBy: string = '';
  Description: string = '';
  DateStart: Date | null = null;
  DateEnd: Date | null = null;
  Order: number | null = null;
  LibertyCode: string = '';
  Default: number | null = null;
  Brand: string = ''; // este campo serve apenas para sincronizar com o webservice
  isMostPopular: boolean = false;
  UUID: string = '';
  UUIDLastChange: string = '';
}

export class CommonAutoBrandModelClass {
  idCommonAutoBrandModel: number | null = null;
  idCommonAutoBrand: number | null = null;
  GroupBy: string = '';
  Description: string = '';
  DateStart: Date | null = null;
  DateEnd: Date | null = null;
  Order: number | null = null;
  LibertyCode: string = '';
  LibertyCodeBrand: string = '';
  Default: number | null = null;
  isMostPopular: boolean = false;
  Model: string = ''; // este campo serve apenas para sincronizar com o webservice
  UUID: string = '';
  UUIDLastChange: string = '';
}

export class CommonAutoBrandModelVersionClass {
  idCommonAutoBrandModelVersion: number | null = null;
  idCommonAutoBrandModel: number | null = null;
  idCommonAutoBrand: number | null = null;
  GroupBy: string = '';
  Description: string = '';
  DateStart: Date | null = null;
  DateEnd: Date | null = null;
  Order: number | null = null;
  LibertyCode: string = '';
  LibertyCodeBrand: string = '';
  Tylacode: number | null = null;
  Default: number | null = null;
  Version: string = ''; // este campo serve apenas para sincronizar com o webservice
  isMostPopular: boolean = false;
  UUID: string = '';
  UUIDLastChange: string = '';
}

export class CommonAutoFuelClass {
  idCommonAutoFuel: number | null = null;
  idProductsTypes: number | null = null;
  Description: string = '';
  DateStart: Date | null = null;
  DateEnd: Date | null = null;
  Order: number | null = null;
  LibertyCode: string = '';
  Default: number | null = null;
  UUID: string = '';
  UUIDLastChange: string = '';
}

export class CommonAutoVehicleSelectionClass {
  idCommonAutoVehicleSelection: number | null = null;
  Description: string = '';
  DateStart: Date | null = null;
  DateEnd: Date | null = null;
  Order: number | null = null;
  LibertyCode: string = '';
  Default: number | null = null;
  UUID: string = '';
  UUIDLastChange: string = '';
}

export class CommonAutoVehicleUsageClass {
  idCommonAutoVehicleUsage: number | null = null;
  Description: string = '';
  DateStart: Date | null = null;
  DateEnd: Date | null = null;
  Order: number | null = null;
  LibertyCode: string = '';
  Default: number | null = null;
  UUID: string = '';
  UUIDLastChange: string = '';
}

export class CommonAutoVehicleTypeClass {
  idCommonAutoVehicleType: number | null = null;
  idProductsTypes: number | null = null;
  Description: string = '';
  DateStart: Date | null = null;
  DateEnd: Date | null = null;
  Order: number | null = null;
  LibertyCode: string = '';
  Default: number | null = null;
  UUID: string = '';
  UUIDLastChange: string = '';
}

export class CommonVesselsPersonalAccidentsClass {
  idCommonVesselsPersonalAccidents: number | null = null;
  Description: string = '';
  DateStart: Date | null = null;
  DateEnd: Date | null = null;
  Order: number | null = null;
  LibertyCode: string = '';
  UUID: string = '';
  UUIDLastChange: string = '';
}

export class CommonPostalCodeClass {
  CodPostal: string = '';
  localidade: string = '';
  morada: string = '';
  desigpostal: string = '';
}

export class CommonSuggestions {
  idCommonsuggestions: number | null = null;
  idCustomer: number | null = null;
  DateStart: Date | null = null;
  DateEnd: Date | null = null;
  Suggestion: string = '';
  UUID: string = '';
  UUIDLastChange: string = '';
}

export class CommonBankClass {
  idBanks: number | null = null;
  Name: string = '';
  ShortName: string = '';
  Cod: string = '';
  DateStart: Date | null = null;
  DateEnd: Date | null = null;
  BICSWIFT: string = '';
  Order: number | null = null;
  UUID: string = '';
  UUIDLastChange: string = '';
}

export class CommonDefaultsClass {
  UseAI: boolean = true;
  UseAIChatbot: boolean = true;
  UseAIEmailTemplates: boolean = true;
  UseAICompareSimulations: boolean = true;
  UseAIPolicyUpload: boolean = true;
  UseAICampaigns: boolean = true;
  UseAITicketDrafting: boolean = true;

  // Configuração do Popup da Área de Cliente
  ClientAreaPopupActive: boolean = false;
  ClientAreaPopupTitle: string = 'Já pode consultar as suas apólices na Área de Cliente da Seguros Virtual';
  ClientAreaPopupBody: string =
    'Caso tenha outros seguros, adicione as apólices para manter tudo organizado num único lugar.';
  ClientAreaPopupBtn1Text: string = 'Ver Apólices';
  ClientAreaPopupBtn1Link: string = '/clientarea/insurancepolicy';
  ClientAreaPopupBtn2Text: string = 'Adicionar Apólices';
  ClientAreaPopupBtn2Link: string = '/clientarea/insurancepolicyupload';
  ClientAreaPopupStartDate: any = null;
  ClientAreaPopupEndDate: any = null;
  idCommercial: number | null = null;
  idCommonNIFType: number | null = null;
  idPaymentsSplit: number | null = null;
  idPaymentsStats: number | null = null;
  idPaymentsTypes: number | null = null;
  idSafeSimulationsStatusTypes: number | null = null;
  idInsuranceClaimsStatusTypes: number | null = null;
  idInsurancePolicyStatusTypes: number | null = null;

  ActualizacaoCapitais: number | null = null;
  DebitoConta: number | null = null;

  Morte: boolean = false;
  MorteAcidente: boolean = false;
  FilhosMenores: boolean = false;
  InvalidezAbsoluta: boolean = false;
  Fraccionamento: string = '';
  ITP60: boolean = false;
  IPOrigem: string = '';
  versao: string = '';
  Modalidade: string = '';
  Dangerous: boolean = false;
  BlockDangerous: boolean = false;
  Sterilized: boolean = false;

  SendSMS: boolean = false;
  SendSMSDays: number | null = null;
  SendWhatsApp: boolean = false;
  SendWhatsAppDays: number | null = null;

  SendEmailDays: number | null = null;
  SendEmail: boolean = false;
  SendSMSInspecAuto: boolean = false;
  SendSMSDaysInspecAuto: number | null = null;
  SendEmailDaysInspecAuto: number | null = null;
  SendEmailInspecAuto: boolean = false;

  SendWhatsAppInspecAuto: boolean = false;
  SendWhatsAppDaysInspecAuto: number | null = null;

  IntervalReadPermissions: number | null = null;
  CreateLogin: boolean = false;
  InsurancePolicyRead: number | null = null;
  InsurancePolicyAdd: number | null = null;
  InsurancePolicyDelete: number | null = null;
  InsurancePolicyEdit: number | null = null;
  SimulationsRead: number | null = null;
  SimulationsAdd: number | null = null;
  SimulationsDelete: number | null = null;
  SimulationsEdit: number | null = null;
  SafeSimulationsRead: number | null = null;
  SafeSimulationsAdd: number | null = null;
  SafeSimulationsDelete: number | null = null;
  SafeSimulationsEdit: number | null = null;
  InsuranceClaimsRead: number | null = null;
  InsuranceClaimsAdd: number | null = null;
  InsuranceClaimsDelete: number | null = null;
  InsuranceClaimsEdit: number | null = null;
  CompaniesContactsRead: number | null = null;
  CompaniesContactsAdd: number | null = null;
  CompaniesContactsDelete: number | null = null;
  CompaniesContactsEdit: number | null = null;
  CompaignsRead: number | null = null;
  CompaignsAdd: number | null = null;
  CompaignsDelete: number | null = null;
  CompaignsEdit: number | null = null;
  ShowNovidadesTab: boolean = false;
  ShowCompaignsTab: boolean = false;
  ShowHomeCarousel: boolean = true;
  ShowHomeMarketingShowcase: boolean = true;
  ShowHomeCampaigns: boolean = true;

  ChangePasswordNextLogon: boolean = false;
  idInsuranceClaimsCausesTypesbreakingglass: number | null = null;
  AppVersion: string = '';

  //             //VIDA PLENA

  ITP: boolean = false;
  PercentagemITP: string = ''; // PercentagemITP60 //  PercentagemITP65 // Nenhum
  ITPAC: boolean = false;
  ListaEspera: boolean = false;
  SubsidioFuneral: boolean = false;
  SubsidioDiarioHospAC: boolean = false;
  ValorDiarioHospAC: number | null = null;
  MorteAcidenteCirculacao: boolean = false;
  FilhosMenoresCargo: boolean = false;
  DoencasGraves: boolean = false;
  DescBoaSaude1PSeg: boolean = false;
  DescBoaSaude2PSeg: boolean = false;
  duasPessoasSeguras: boolean = false;

  idMessageCenterStatus: number | null = null;
  UUID: string = '';
  UUIDLastChange: string = '';
}

export class GenreClass {
  idCommonGenre: number | null = null;
  Description: string = '';
  CodeGenre: string = '';
  Order: number | null = null;
  UUID: string = '';
  UUIDLastChange?: any;
}

export class BreedsClass {
  idCommonbreeds: number | null = null;
  idProductsTypes: number | null = null;
  Description: string = '';
  Dangerous: boolean = false;
  Order: number | null = null;
  UUID: string = '';
  UUIDLastChange?: any;
}

export class BreedsTypeClass {
  idCommonbreedsType: number | null = null;
  Description: string = '';
  Order: number | null = null;
  UUID: string = '';
  UUIDLastChange?: any;
}

export class AppMessages {
  Auth: false | null = null;
  Type: AlertType | null = null;
  Message: string = '';
  Token: string = '';
  Continue: false | null = null;
  Code: string = '';
  autoClose: boolean = false;
  keepAfterRouteChange: boolean = false;
  UUIDLastChange: string = '';
}

export enum AlertType {
  Success,
  Error,
  Info,
  Warning,
}

export class RoutesConfig {
  HideHome: boolean = false;
  HideSimulations: boolean = false;
  HidePolicies: boolean = false;
  HideInsuranceclaims: boolean = false;
  HideContacts: boolean = false;
  HideSitemanagement: boolean = false;
  HideCommercialarea: boolean = false;
  HideIntermediaryArea: boolean = false;
  HideClientarea: boolean = false;
  HideInfoContent: boolean = false;
  UUIDLastChange: string = '';
}

export class EmailClass {
  NIF: string = '';
  from: string = '';
  to: string = '';
  cc: string = '';
  bcc: string = '';
  subject: string = '';
  text: string = '';
  html: string = '';
  nomecompleto: string = '';
  email: string = '';
  telefone: string = '';
  mensagem: string = '';
  attachments: AttachmentsClass[] = [];
  UUIDLastChange: string = '';
}

export class AttachmentsClass {
  filename: string = '';
  file: any;
  path: string = '';
  pathexternal: boolean = false;
  cid: string = '';
  buffer?: Buffer;
  contentType?: string;
}

export class SexTypesClass {
  idSexTypes: number | null = null;
  Description: string = '';
  DateStart: Date = new Date();
  DateEnd: Date = new Date();
  LibertyCode: string = '';
  AGEAS: string = '';
  Tranquilidade: string = '';
  SabSeg: string = '';
  isCompany: boolean = false;
  Order: number = 0;
  UUID: string = '';
  UUIDLastChange: string = '';
}

export class EmailsTemplateClass {
  idEmailsTemplates: number | null = null;
  From: string = '';
  To: any;
  Subject: string = '';
  HTMLText: any;
  Description: string = '';
  DateStart: string = '';
  DateEnd: string = '';
  UUID: string = '';
  UUIDLastChange: string = '';
}

export class MaritalStatusClass {
  idMaritalStatus: number | null = null;
  Description: string = '';
  LibertyCode: string = '';
  AGEAS: string = '';
  Tranquilidade: string = '';
  SabSeg: string = '';
  Order: number | null = null;
  DateStart: string = '';
  DateEnd: string = '';
  UUID: string = '';
  UUIDLastChange: string = '';
}

export class ProfessionalsituationClass {
  idProfessionalsituation: number | null = null;
  Description: string = '';
  LibertyCode;
  Order: number | null = null;
  DateStart: string = '';
  DateEnd: string = '';
  UUID: string = '';
  UUIDLastChange: string = '';
}

export class CommonNIFTypeClass {
  idCommonNIFType: number | null = null;
  Description: string = '';
  Order: any;
  UUID: any;
  UUIDLastChange?: any;
}

export class CommonCAEClass {
  CAE: number | null = null;
  ATIVIDADE: string = '';
  DateStart: Date | null = null;
  DateEnd: Date | null = null;
  UUID: string = '';
  UUIDLastChange: string = '';
}

export class CommonVesselsHullMaterialClass {
  idCommonVesselsHullMaterial: number | null = null;
  Description: string = '';
  DateStart: Date | null = null;
  DateEnd: Date | null = null;
  Order: number | null = null;
  LibertyCode: string = '';
  LibertyShowCapital: boolean = false;
  UUID: string = '';
  UUIDLastChange: string = '';
}

export class CommonVesselsNavigationZoneClass {
  idCommonVesselsNavigationZone: number | null = null;
  Description: string = '';
  DateStart: Date | null = null;
  DateEnd: Date | null = null;
  Order: number | null = null;
  LibertyCode: string = '';
  UUID: string = '';
  UUIDLastChange: string = '';
}

export class CommonVesselsTonnageClass {
  idCommonVesselsTonnage: number | null = null;
  Description: string = '';
  DateStart: Date | null = null;
  DateEnd: Date | null = null;
  Order: number | null = null;
  LibertyCode: string = '';
  UUID: string = '';
  UUIDLastChange: string = '';
}

export class CommonVesselsDamageClass {
  idCommonVesselsDamage: number | null = null;
  Description: string = '';
  DateStart: Date | null = null;
  DateEnd: Date | null = null;
  Order: number | null = null;
  LibertyCode: string = '';
  Default: boolean = false;
  UUID: string = '';
  UUIDLastChange: string = '';
}

// Generated by https://quicktype.io

export class CommonVesselsTypeClass {
  idCommonVesselsType: number | null = null;
  Description: string = '';
  DateStart: Date | null = null;
  DateEnd: Date | null = null;
  Order: number | null = null;
  LibertyCode: string = '';
  LibertyMaxLotacao: number | null = null;
  libertyMaxPotencia: number | null = null;
  LibertyMinAnos: number | null = null;
  UUID: string = '';
  UUIDLastChange: string = '';
}

export class CommonPetsAgeClass {
  idPetsAge: number | null = null;
  Description: string = '';
  DateStart: Date | null = null;
  DateEnd: Date | null = null;
  FidelidadeCode: string = '';
  Order: number | null = null;
  UUID: string = '';
  UUIDLastChange: string = '';
}

export class CommonFieldTypeClass {
  idCommonFieldType: number | null = null;
  idProductsTypes: number | null = null;
  FieldType: string = '';
  OriginalFieldType: string = '';
  Description: string = '';
  MatchPhrase: string = '';
  isFile: boolean = false;
  isBoolean: boolean = false;
  isFilter: boolean = false;
  DateStart: Date | null = null;
  DateEnd: Date | null = null;
  Explanation: string = '';
  Order: number | null = null;
  UUID: string = '';
  UUIDLastChange: string = '';
}

export class FilesStructureClass {
  idFilesStructure: number | null = null;
  idProduct: number | null = null;
  idProductsTypes: number | null = null;
  Source: string = '';
  Name: string = '';
  Value: string = '';
  Tolltip: string = '';
  AGEASCodes: string = '';
  TranquilidadeCodes: string = '';
  DateStart: Date | null = null;
  DateEnd: Date | null = null;
  Icon: string = '';
  CartaVerde: boolean = false;
  Others: boolean = false;
  Order: number | null = null;
  UUID: string = '';
  UUIDLastChange: string = '';
}

export class Image {
  type: string = '';
  data: number[] = [];
  UUIDLastChange: string = '';
}

export class Blob {
  type: string = '';
  data: number[] = [];
  UUIDLastChange: string = '';
}

export class Steps {
  id: number | null = null;
  Name: string = '';
  active: boolean = false;
  completed: boolean = false;
  invalid: boolean = false;
  ngForm: NgForm | null = null;
  /** Quando true, o getter isCurrentQuizStepValid não auto-corrige o invalid via ngForm */
  useManualValidation: boolean = false;
  // mattabcontent: any;
}

export class Icon {
  type: string = '';
  data: number[] = [];
  UUIDLastChange?: string = '';
}

export class CommumDriveLicenceCategoryClass {
  idCommonDriveLicenceCategory: number | null = null;
  Description: string = '';
  DateStart: Date | null = null;
  DateEnd: Date | null = null;
  DrivinglicenseDate: Date | null = null;
  DrivinglicenseExpirationDate: Date | null = null;
  Icon: any = null;
  Order: number | null = null;
  selected: boolean = false;
  UUID: string = '';
  UUIDLastChange: string = '';
}

export class CommonPostalAddressResultClass {
  // Campos principais retornados pela API
  Morada: string = ''; // Endereço completo formatado
  Localidade: string = ''; // Nome da localidade
  Concelho: string = ''; // Nome do concelho
  Distrito: string = ''; // Nome do distrito
  CodigoPostal: string = ''; // Código postal no formato "XXXX-XXX"
  CP4: string = ''; // Primeira parte do CP (XXXX)
  CP3: string = ''; // Segunda parte do CP (XXX)

  // Campos adicionais para controle
  selected: boolean = false;
  UUID: string = '';
  UUIDLastChange: string = '';
  DateStart: Date | null = null;
  DateEnd: Date | null = null;

  constructor(data?: Partial<CommonPostalAddressResultClass>) {
    if (data) {
      Object.assign(this, data);

      // Garantir que o código postal está formatado
      if (this.CP4 && this.CP3 && !this.CodigoPostal) {
        this.CodigoPostal = `${this.CP4}-${this.CP3}`;
      }
    }
  }

  // Método para obter a morada formatada
  getFormattedAddress(): string {
    const parts = [this.Morada, this.Localidade, this.Concelho, this.Distrito, this.CodigoPostal].filter(
      part => part && part.trim() !== '',
    );

    return parts.join(', ');
  }

  // Método para verificar se a morada é válida
  isValid(): boolean {
    return !!this.Morada && !!this.Localidade && !!this.CodigoPostal;
  }
}
